export function canSupplyStock(account) {
  return !!account && [1, 4, 6].indexOf(Number(account.idRole)) >= 0 &&
    account.idSekolah == null && account.idDinasPemda == null && account.idDinas == null;
}

export function newStockRequestId() {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, value => value.toString(16).padStart(2, "0")).join("");
  return [hex.slice(0, 8), hex.slice(8, 12), hex.slice(12, 16), hex.slice(16, 20), hex.slice(20)].join("-");
}

export function validStockInput(quantity, note) {
  return /^[1-9][0-9]{0,4}$/.test(String(quantity)) && Number(quantity) <= 10000 &&
    typeof note === "string" && note.trim().length > 0 && note.trim().length <= 250 && !/[\u0000-\u001f\u007f-\u009f]/.test(note);
}
